import { FC, useState } from "react";

import {
  CampaignBody,
  VisualProductDataCampaignColorParameters,
} from "@vviinn/user-managment-client-ts";

import { CollapsedFields } from "../../../components/GeneralUI/CollapsedFields/CollapsedFields";
import { NamedNumberic } from "../../../ui/layout/molecules/NamedNumberic";
import { capitalizeAssociatedPress } from "../../../helpers/string/capitalize";
import { calculateNewConfig } from "../helpers";
import {
  colorModalSettings,
  colorNumericSettings,
  colorSettingsTitles,
} from "../../constants";
import { AcceptableNamedRow } from "../../../ui/layout/organisms/SlideOver/SlideOverFixedLayouts/AcceptableNamedRow";
import { isActive } from "../../../helpers";
import { UpdateCampaignProps } from "../types";

export const ColorAcceptableRow: FC<
  React.PropsWithChildren<UpdateCampaignProps>
> = ({ campaign, updateCampaignBody }) => {
  const [config, setConfig] = useState<CampaignBody>({});
  const configChanged = Object.keys(config).length > 0;

  const { colorParameters } = campaign;

  const handleChange =
    (key: keyof VisualProductDataCampaignColorParameters) =>
    (target: HTMLInputElement) => {
      setConfig(
        calculateNewConfig(
          true,
          config,
          key,
          target.value,
          colorParameters?.[key],
        ),
      );
    };

  return (
    <AcceptableNamedRow
      title="Color"
      allowSubmit={configChanged}
      permissionsGroup="campaign:advanced_config"
      content={isActive(!!campaign?.productAttributes?.includes("color"))}
      initConfig={() => setConfig({})}
      onSubmit={() => updateCampaignBody(config)}
    >
      <CollapsedFields
        title="Color Settings"
        isSwitchable={false}
        active={true}
      >
        {colorNumericSettings.map((key, index) => {
          const { min, max } = colorModalSettings[key];
          return (
            <NamedNumberic
              key={index}
              title={capitalizeAssociatedPress(colorSettingsTitles[key])}
              value={colorParameters?.[key]}
              onChange={handleChange(key)}
              min={min}
              max={max}
            />
          );
        })}
      </CollapsedFields>
    </AcceptableNamedRow>
  );
};
